<script setup lang='ts'>
    import { ref, computed } from "vue";
    import * as lucideIcons from "lucide-vue-next";

    type Icon = keyof typeof lucideIcons;
    
    const props = withDefaults(defineProps<{
        title?: string
        icon?: Icon
        variant?: "default" | "success" | "warning" | "danger" | "information" | "secondary"
        dismissible?: boolean
    }>(), {
        icon: "TriangleAlert",
        variant: "default",
        dismissible: false
    })

    const isDismissed = ref(true);

    const computedClass = computed(() => {
        return {
            'items-start sm:items-center': props.title && props.title.length > 230,
            'bg-transparent border-none text-slate-400 !px-0 !py-0': props.variant === 'default',
            'bg-[#EBFFEA] border-custom-success text-custom-success': props.variant === 'success',
            'bg-[#FCEBD8] border-custom-warning text-custom-warning': props.variant === 'warning',
            'bg-[#FFEAEA] border-custom-muted-red text-custom-muted-red': props.variant === 'danger',
            'bg-[#FEFEF0] border-custom-information text-custom-information': props.variant === 'information',
        }
    })

    const computedDismissibleClass = computed(() => {
        return {
            'bg-custom-muted-red text-white': props.variant === 'danger',
            'bg-custom-information text-white': props.variant === 'information',
            'bg-custom-success text-white': props.variant === 'success',
            'bg-slate-400 text-white': props.variant === 'default',
            'bg-custom-secondary/15 border-custom-secondary text-custom-secondary': props.variant === 'secondary',
        }
    })

</script>

<template>
    <div v-if="isDismissed"
        class="flex gap-2 justify-center border-2 rounded-lg max-w-max px-2 py-2 h-min -intro-y "
        :class="computedClass">
        <div class="flex gap-2">
            <component
                :is="lucideIcons[icon]"
                class="stroke-2 size-4 flex-shrink-0 mt-0.5"
            />
            <slot>
                <span class="font-medium text-xs">{{ title }}</span> 
            </slot>
        </div>
        <div v-if="dismissible"
            :class="computedDismissibleClass"
            class="rounded-full p-0.5 absolute -top-1.5 -right-1.5">
            <component
            :is="lucideIcons['X']"
            class="size-3"
            @click="isDismissed = false"
        />
        </div>
    </div>
</template>